import { type FormDefinition, isField } from "@fobu/schema";

/** Name und E-Mail aus der Einladung in passende Felder übernehmen (nur wenn noch leer). */
export function inviteAnswers(def: FormDefinition, inv: { name: string | null; email: string }): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  const fields = def.pages.flatMap((p) => p.blocks).filter(isField);
  const email = fields.find((f) => f.type === "email");
  if (email) out[email.id] = inv.email;
  if (inv.name) {
    const first = fields.find((f) => f.type === "short_text" && /^(vorname|first_?name)$/.test(f.key));
    const last = fields.find((f) => f.type === "short_text" && /^(nachname|last_?name)$/.test(f.key));
    const full = fields.find((f) => f.type === "short_text" && /^(name|vor_und_nachname|dein_name|dein_name_optional|ihr_name|wie_heisst_du|wie_heissen_sie)$/.test(f.key));
    const parts = inv.name.trim().split(/\s+/);
    if (first && last && parts.length > 1) (out[first.id] = parts.slice(0, -1).join(" "), (out[last.id] = parts.at(-1)));
    else if (full) out[full.id] = inv.name;
    else if (first) out[first.id] = inv.name;
  }
  return out;
}
